import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import compose from 'recompose/compose';
import utils from 'helpers/utils';
import { FileDownloadIcon } from 'assets/materialIcons/materialIcons';
import theme from 'theme/theme';
import { connect } from 'react-redux';
import { exportFullBookings } from 'store/actions/bookings/fullBookingExport';

const FullBookingCSVExport = (props) => {
    const {
        allowedMaxAmount,
        label,
        total,
    } = props;

    const onClickExport = () => {
        const {
            base,
            exportFullBookings,
            filterValues,
        } = props;

        const filters = utils.buildFilterObject(filterValues);

        exportFullBookings({
            base: base,
            filters: filters,
        });
    };

    const exceedsMaxAmount = total > allowedMaxAmount;

    return (
        <Button
            icon={ <FileDownloadIcon color={ exceedsMaxAmount ? theme.palette.doveGray : theme.palette.primary1Color } /> }
            disabled={ exceedsMaxAmount }
            onClick={ onClickExport }
            style={ { color: (exceedsMaxAmount ? theme.palette.doveGray : theme.palette.primary1Color) } }
            title={ label }
        />
    );
};

const enhance = compose(
    connect(
        null,
        {
            exportFullBookings: exportFullBookings,
        }
    ),
);

FullBookingCSVExport.defaultProps = {
    allowedMaxAmount: 10000,
};

FullBookingCSVExport.propTypes = {
    allowedMaxAmount: PropTypes.number,
    base: PropTypes.string,
    exportFullBookings: PropTypes.func.isRequired,
    filterValues: PropTypes.object,
    label: PropTypes.string,
    total: PropTypes.number,
};

export default enhance(FullBookingCSVExport);


// WEBPACK FOOTER //
// ./src/pages/bookings/list/actions/csv/FullBookingCSVExport.js